<template>
  <div
    :class="{ 'w-product-attribute-filter d-flex full-width': true, 'flex-wrap': withFlexWrapClass }"
  >
    <WorkCategoryTreeFilter
      v-if="enableCategoryFilter"
      :label="categoryLabel"
      :value="categoryValue"
      :filter-name="categorySearchKey"
      :params="attributeValueFilter"
      :path="categoryPath"
      :category-option-search-key="categoryOptionSearchKey"
      :category-table-filters="useCategoryTableFilter ? categoryTableFilters : undefined"
      :disabled="disabled"
      :additional-categories="additionalCategories"
      item-text="data.label"
      item-children="data.children"
      item-value="id"
      @input="handleCategoryInput"
    />
    <WorkCategoryAttributeFilter
      :label="attributeLabel"
      :value="sortedAttributeValue"
      :filter-name="attributeSearchKey"
      :params="attributeCategoryFilter"
      :path="attributePath"
      clearable
      :selected.sync="selectedAttributes"
      :attribute-option-search-key="attributeOptionSearchKey"
      :disabled="disabled"
      :has-filter-option="withAttributeRelation"
      :attribute-table-filters="useAttributeTableFilter ? attributeTableFilters : undefined"
      :mandatory-filters="mandatoryFilters"
      @input="handleAttributeInput"
    />
  </div>
</template>

<script>
/** COMPONENTS **/
import WorkCategoryAttributeFilter
  from "@/components/global_components/filters/category_attribute_filter/WorkCategoryAttributeFilter";
import WorkCategoryTreeFilter
  from "@/components/global_components/filters/category_filter/WorkCategoryTreeFilter"
//helpers
import { parseFilters } from '@/services/parsing_services/filter-service';
import i18n from "@/language/i18n";
import isEqual from 'lodash/isEqual';

export default {
  name: "WorkCategoryAndAttributeFilter",
  components: { WorkCategoryTreeFilter, WorkCategoryAttributeFilter },
  props: {
    value: { type: Object, required: false },
    categorySearchKey: { type: String, default: "categories" },
    categoryAttributeSearchKey: { type: String },
    categoryOptionSearchKey: { type: String, default: "categoryRelation" },
    categoryPath: { type: String, default: 'productcategories/treehierarchy' },
    categoryLabel: { type: String, default: i18n.t('Common.categories') },
    disabled: { type: Boolean, default: false },
    attributeSearchKey: { type: String, default: "attributes" },
    attributePath: { type: String, default: 'productcategories/attributes' },
    attributeLabel: { type: String, default: i18n.t('Common.attributes') },
    useCategoryTableFilter: { type: Boolean, default: false },
    useAttributeTableFilter: { type: Boolean, default: false },
    label: { type: String },
    withFlexWrapClass: { type: Boolean, default: true },
    useAttributeValueFilter: { type: Boolean, default: false },
    useAttributeCategoryFilter: { type: Boolean, default: true },
    withAttributeRelation: { type: Boolean, default: true },
    attributeOptionSearchKey: { type: String, default: "attributeRelation" },
    enableCategoryFilter: { type: Boolean, default: true },
    mandatoryFilters: { type: Object, default: undefined },
    additionalCategories: { type: Array },
  },
  data() {
    return {
      selectedAttributes: [],
    }
  },
  computed: {
    categoryTableFilters() {
      return {
        categoryRelation: this.value?.categoryRelation ?? 'or',
        categories: this.value?.[this.categorySearchKey]
      }
    },
    attributeTableFilters() {
      return {
        attributeRelation: this.value?.attributeRelation ?? 'or',
        attributes: this.value?.[this.attributeSearchKey]
      }
    },
    categoryValue() {
      return this.value?.[this.categorySearchKey] ?? [];
    },
    attributeValue() {
      return this.value?.[this.attributeSearchKey] ?? [];
    },
    sortedAttributeValue() {
      return [...(this.attributeValue ?? [])].sort((a, b) =>
        a.localeCompare(b)
      )
    },
    selectedAttributesIds() {
      if (this.selectedAttributes?.length == 0 || this.selectedAttributes == undefined) return undefined
      else return this.selectedAttributes?.map(attribute => {
        let splitAttribute = attribute.split(':');
        return splitAttribute[0]
      })
    },
    attributeValueFilter() {
      if (this.useAttributeValueFilter) {
        if (this.selectedAttributesIds == undefined) return undefined;
        return parseFilters({ attributes: [...new Set(this.selectedAttributesIds)] });
      }
      return {}
    },
    categoryAttributeKey() {
      return this.categoryAttributeSearchKey ?? this.categorySearchKey
    },
    attributeCategoryFilter() {
      if (this.useAttributeCategoryFilter) {
        if (this.categoryValue == undefined && this.categoryValue?.length === 0) return undefined
        return { [`${this.categoryAttributeKey}`]: this.categoryValue }
      }
      return {}
    },
  },
  methods: {
    _handleInput(value, searchKeyOverride) {
      return this.$emit('input', {
        preventDefault: true,
        searchKeyOverride,
        value
      });
    },
    _isOptionInput(value, optionSearchKey) {
      return typeof value === 'object' && value.searchKeyOverride === optionSearchKey;
    },
    handleCategoryInput(value) {
      if (this._isOptionInput(value, this.categoryOptionSearchKey)) {
        this.categoryRelation = value.value;
        return this._handleInput(value.value, value.searchKeyOverride);
      }
      else {
        if (value == []) this._handleInput(null, this.attributeSearchKey)

        this._handleInput(value, this.categorySearchKey);
      }
    },
    handleAttributeInput(value) {
      if (this._isOptionInput(value, this.attributeOptionSearchKey)) {
        this.attributeRelation = value.value;
        return this._handleInput(value.value, value.searchKeyOverride);
      }
      else {
        if ((this.attributeValue?.length < 1 && value?.length < 1) || isEqual(value, this.attributeValue)) return;
        if (value == []) return this._handleInput(null, this.categorySearchKey)

        this._handleInput(value, this.attributeSearchKey);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.w-product-attribute-filter {
  gap: $grid-gutter;
}
</style>
